import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {HeaderModule} from './header/header.module';
import {FooterComponent} from './footer';
import {NavigationModule} from './navigation';
import {RibbonComponent} from './ribbon';
import {ShortcutComponent} from './shortcut';
import {LayoutSwitcherComponent} from './layout-switcher.component';
import {MainLayoutComponent} from './app-layouts/main-layout.component';
import {EmptyLayoutComponent} from './app-layouts/empty-layout.component';
import {RouterModule} from '@angular/router';
import {AuthLayoutComponent} from './app-layouts/auth-layout.component';
import {TooltipModule, BsDropdownModule} from 'ngx-bootstrap';
import {RouteBreadcrumbsComponent} from './ribbon/route-breadcrumbs.component';
import {UtilsModule} from '../utils/utils.module';
import {I18nModule} from '../i18n/i18n.module';

@NgModule({
    imports: [
        CommonModule,
        HeaderModule,
        NavigationModule,
        FormsModule,
        RouterModule,

        UtilsModule,


        TooltipModule,
        BsDropdownModule,
        I18nModule
    ],
    declarations: [
        FooterComponent,
        RibbonComponent,
        ShortcutComponent,
        LayoutSwitcherComponent,
        MainLayoutComponent,
        EmptyLayoutComponent,
        AuthLayoutComponent,
        RouteBreadcrumbsComponent,
    ],
    exports: [
        HeaderModule,
        NavigationModule,
        FooterComponent,
        RibbonComponent,
        ShortcutComponent,
        LayoutSwitcherComponent,
    ]
})
export class SmartadminLayoutModule {

}



// WEBPACK FOOTER //
// ./src/app/shared/layout/layout.module.ts